import React from 'react'
import { Stack, Typography, SxProps } from '@mui/material'
import { J2Caution } from '@e3dc-react/icons'
import { StyledContainer } from './styles'

interface Props {
  title?: string
  message: string
  iconSx?: SxProps
  containerSx?: SxProps
}

/**
 * Component to display a warning message
 */
const WarningMessage: React.FC<Props> = ({ message, title, iconSx, containerSx }) => {
  return (
    <StyledContainer sx={containerSx}>
      <J2Caution sx={iconSx} />
      <Stack>
        {title && <Typography variant="h3">{title}</Typography>}
        <Typography variant="body1">{message}</Typography>
      </Stack>
    </StyledContainer>
  )
}

export default WarningMessage
